import React from "react"
import Tips from '../components/tips'
import BlockHowToGuidesDemolition from "../components/how-to-guides-demolition"
import ServicesDemolition from "../components/services-demolition"
import LayoutDemolition from "../components/layout-demolition"
import SidebarForm from "../components/sidebarForm"

const COMMONDEMOLITION = ({ pageContext }) => 
{ 
    const code = pageContext.code;
    const env = pageContext.env;       
    const populars = pageContext.populars.length > 0 ? pageContext.populars : [];   
    const body = pageContext.content.content !== undefined ? pageContext.content.content: '';

    const seo = 
    {
        url: pageContext.url,
        title: pageContext.content.seo_title,
        description: pageContext.content.seo_desc,
        env: env,
        code: code,
        page: 'basic'
    }

    return (
        <LayoutDemolition seo={seo} env={env} code={code} hidden={true} callToAction={true} >
            
            <div className="blog">

                <div className="container mb-5">
                    <div className="row">
                        <div className="col-lg-8 common">
                             <div class="post single-item">                
                                <div className="resume">                                    
                                    <div class="body" 
                                        dangerouslySetInnerHTML={{__html: body}}></div>
                                </div>
                            </div>                        
                        </div>
                        <div className="col-lg-4">
                            <div className="sidebar no-margin">
                                <div className="block">
                                    <div className="card mb-5">                                   
                                        <SidebarForm site={env.site} code="demolition" section="blogs"/>
                                    </div>
                                </div>

                                <div className="block">
                                    <ServicesDemolition  env={env} />
                                </div>

                                <div className="block">
                                    <BlockHowToGuidesDemolition  />
                                </div>

                                <div className="block">
                                    <Tips populars={populars}/>
                                </div>                              

                            </div>                            
                        </div>
                    </div>
                </div> 
            
            
            </div> 

        </LayoutDemolition>
    )
};

export default COMMONDEMOLITION;